import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "./screens/Home";

// Game screens and the content admin load on demand so the home route stays
// small on budget phones.
const RoomScreen = lazy(() => import("./screens/RoomScreen"));
const AdminApp = lazy(() => import("./admin/AdminApp"));

export function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<main className="screen" aria-busy="true" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/r/:code" element={<RoomScreen />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
